import { Profile, getSetting, shopAssetsInfo, shopInfo } from "@/api/index";
import dayjs from "dayjs";
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import localStorage from "../utils/localStorage.js";
import design from "./modules/design";
import scoket from "./modules/scoket";

Vue.use(Vuex);

/**
 * 登录状态监控器，用于检查 token 是否过期
 */
const loginMonitorPlugin = (store) => {
  let timer = null;
  const checkExpiration = () => {
    const expired_time = localStorage.get("expired_time");
	console.log('expired_time',expired_time,'curr_time',dayjs().isAfter(parseInt(expired_time) * 1000));
    const now = dayjs();
    if (!expired_time || expired_time === "undefined") {
      store.commit("clearLoginState");
      return;
    }

    const expired = dayjs(parseInt(expired_time) * 1000);
    if (now.isAfter(expired)) {
      console.log("token已过期，自动登出");
      store.commit("clearLoginState");
    }
  };

  checkExpiration();

  //>订阅 state 变化
  store.subscribe((mutation, state) => {
	console.log('[LoginMonitor] 捕获到 Mutation:', mutation.type);
    //>当登录状态发生变化时触发
    if (mutation.type === "login" || mutation.type === "update_login_state") {
      if (state.is_login) {
        //>立即检查一次
        checkExpiration();

        //>如果存在定时器则清除旧的定时器
        if (timer) clearInterval(timer);

        //>设置定时检查（例如每30秒检查一次，避免频繁计算）
        //>如果只需要在切换页面时检查，可以不需要定时器，只在路由守卫中检查
        timer = setInterval(checkExpiration, 30 * 1000);
      } else {
        //>登出时清除定时器
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }
    }

    //>监听 clearLoginState 确保清理
    if (mutation.type === "clearLoginState" || mutation.type === "logout") {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
  });
};

export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  state: {
    //isLogin: localStorage.get('ACCESS_TOKEN') ? true : false,
    userInfo: JSON.parse(localStorage.get("USER_INFO")),
    token: localStorage.get("ACCESS_TOKEN"),
    aliyun_oss: null,
    // Header判断是否登录使用
    is_login: false,
    setting: null,
    taskSetting: {},
    parent_code: "",
    channel: "",
    breadCrumbs: [{ name: "团队资源", uuid: "-1" }],
    shopInfo: {},
  },
  getters: {
    // 路由，页面中实时判断是否登录过期
    isLoginDynamic: (state) => () => {
      return !!state.token;
    },
    isSettingLoad: (state) => () => {
      return !!state.setting;
    },
  },
  mutations: {
    login(state, provider) {
      state.token = provider.token;
      state.is_login = true;
      localStorage.set("ACCESS_TOKEN", provider.token);
      localStorage.set("expired_time", provider.time);
    },
    logout(state) {
      // state.loginInfo = {};
      state.userInfo = {};
      state.token = null;
      state.is_login = false;
      localStorage.remove("ACCESS_TOKEN");
      localStorage.remove("USER_INFO");
    },
    setUserInfo(state, provider) {
      state.userInfo = provider;
      localStorage.set("USER_INFO", provider);
    },
    setAliYunOSS(state, provider) {
      state.aliyun_oss = provider;
    },
    update_login_state(state, bool) {
      state.is_login = bool;
    },
    updateSetting(state, setting) {
      state.setting = setting;
    },
    updateUserTaskSetting(state, setting) {
      state.taskSetting = setting;
    },
    clearLoginState(state) {
      state.is_login = false;
      state.userInfo = {};
      state.token = null;
      localStorage.remove("expired_time");
      localStorage.remove("ACCESS_TOKEN");
      localStorage.remove("USER_INFO");
    },
    setParentCode(state, code) {
      console.error(code, "code");
      state.parent_code = code;
    },
    setChannel(state, c) {
      state.channel = c;
    },
    SET_BREADCRUMBS(state, breadcrumbs) {
      state.breadCrumbs = breadcrumbs;
    },
    CLEAR_BREADCRUMBS(state) {
      state.breadCrumbs = [{ name: "团队资源", uuid: "-1" }];
    },
    updateShopInfo(state, info) {
      state.shopInfo = info;
    },
  },
  actions: {
    async getSetting(context) {
      const { data } = await getSetting();
      context.commit("updateSetting", data);
    },
    async getUser(context) {
      const { data } = await Profile();
      context.commit("setUserInfo", data);
    },
    checkExpiredTime(context) {
      const expired_time = localStorage.get("expired_time");
      const now = dayjs();
      const expired = dayjs(parseInt(expired_time) * 1000);
      if (
        now.isAfter(expired) ||
        !expired_time ||
        expired_time === "undefined"
      ) {
        console.log("token已过期");
        context.commit("clearLoginState");
      }
    },
    setBreadcrumbs({ commit, state }, breadcrumbs) {
      //>如果传入的是单个对象，将其转换为数组
      let breadcrumbArray = [];
      if (breadcrumbs && !Array.isArray(breadcrumbs)) {
        breadcrumbArray = [breadcrumbs];
      } else if (Array.isArray(breadcrumbs)) {
        breadcrumbArray = breadcrumbs;
      }

      //>如果传入的面包屑数组为空，则清空现有面包屑
      if (!breadcrumbArray || breadcrumbArray.length === 0) {
        commit("CLEAR_BREADCRUMBS");
        return;
      }
      const firstCrumb = breadcrumbArray[0];
      let existingIndex = -1;
      if (state.breadCrumbs.length > 0 && firstCrumb.uuid != "-1") {
        //>查找传入的第一个面包屑是否已经在当前状态中存在
        existingIndex = state.breadCrumbs.findIndex(
          (crumb) =>
            crumb.uuid &&
            firstCrumb.uuid &&
            crumb.uuid === firstCrumb.uuid &&
            crumb.name &&
            firstCrumb.name &&
            crumb.name === firstCrumb.name
        );
      } else {
        //>如果点击了根目录,则初始化面包屑选项
        commit("CLEAR_BREADCRUMBS");
      }

      let newBreadcrumbs;
      if (existingIndex !== -1) {
        //>如果存在，截取该面包屑之前的部分，然后拼接新的面包屑
        newBreadcrumbs = [
          ...state.breadCrumbs.slice(0, existingIndex),
          ...breadcrumbArray,
        ];
      } else {
        //>如果不存在，直接使用新的面包屑
        newBreadcrumbs = [...state.breadCrumbs, ...breadcrumbArray];
      }

      commit("SET_BREADCRUMBS", newBreadcrumbs);
    },
    clearBreadcrumbs({ commit }) {
      commit("CLEAR_BREADCRUMBS");
    },
    async getShopInfo(context) {
      if (!context.state.userInfo.id) return;
      const { data: dataInfo } = await shopInfo();
      const { data: dataAssets } = await shopAssetsInfo();
      const data = { ...dataInfo, ...dataAssets };
      console.log("data---shop", data);
      context.commit("updateShopInfo", data);
    },
  },
  modules: {
    design,
    scoket,
  },
  plugins: [
    createPersistedState({
      paths: ['token', 'is_login', 'userInfo', 'setting', 'taskSetting', 'parent_code', 'channel', 'breadCrumbs', 'shopInfo', 'scoket']
    }),
    loginMonitorPlugin
  ],
});
